import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    // Ensure chart data is properly formatted
    try {
      this.setState({
        chartData: this.props.chartData || [],
        chartOptions: this.props.chartOptions || {},
      });
    } catch (error) {
      console.warn('Error setting chart data:', error);
      this.setState({
        chartData: [],
        chartOptions: {},
      });
    }
  }

  render() {
    // Safety check to prevent ApexCharts errors
    if (!this.state.chartData || !this.state.chartOptions || 
        !Array.isArray(this.state.chartData) || this.state.chartData.length === 0) {
      return <div>Loading chart...</div>;
    }

    return (
        <Chart
          options={this.state.chartOptions}
          series={this.state.chartData}
          type="bar"
          width="100%"
          height="100%"
        />
    );
  }
}

export default BarChart;
